<template>
  <div class="tgh-residential tgh-page">
    <TitlePage title="RESIDENTIAL" :desc="summary"></TitlePage>
    <div class="tgh-residential-option" v-if="residentialList.length > 0">
      <div class="row no-gutters">
        <div class="col" v-for="(res,resIndex) in residentialList" :key="`res-item-${resIndex}`">
          <router-link :to="`residential/${res.title}`">
            <img :src="res.photo" alt="" v-if="res.photo_available">
            <h1>{{ res.title }}</h1>
          </router-link>
        </div>
      </div>
    </div>
    <div class="tgh-blank" v-if="residentialList.length < 1"></div>
    <AddressNav></AddressNav>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import AddressNav from '@/components/AddressNav.vue'
import TitlePage from '@/components/TitlePage.vue'
export default {
  name: 'Residential',
  components: {
    AddressNav,
    TitlePage
  },
  data() {
    return {
      residentialList : [],
      summary : []
    }
  },
  methods : {
    getData(){
      let vm = this
      let url = apiUrl+'/residential?sort=id&page=1&per_page=100'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.residentialList = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    },
    getSummary() {
      let vm = this
      let url = apiUrl+'/home/summary'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.summary = response.data.data.residential
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  mounted() {
    this.getData()
    this.getSummary()
  }
}
</script>
